import {CurrentMuellkalenderWidget} from "./widgets/current-muellkalender";


export const widgets = {
    "teamprogramming:current-muellkalender": CurrentMuellkalenderWidget,
};